<sd-border-wrapper
  [hasBorder]="hasBorder"
  [titleLevel]="1"
  [isReinsurance]="true"
  [title]="title"
  [subTitle]="subTitle"
  [description]="description"
>
  <div class="c__search-sis">
    <form novalidate [formGroup]="formGroup" class="d-column" id="accessory-search">
      <div class="c__form-row">
        <div class="c__form-item">
          <sd-form
            autocomplete
            formControlName="autocomplete"
            [labelTitle]="'sis.search.title' | translate"
            [properties]="['term']"
            [clearAfterSelectElement]="false"
            [elements]="autocompleteElement"
            [placeholder]="'sis.search.placeholder' | translate"
            [minLength]="2"
            (inputChanged)="searchProduct($event)"
          />
          <div class="c__how-to-find">
            <a class="has-icon d-flex align-items-center" (click)="openModalRef()">
              <sd-icon name="icon-help" [size]="iconSize.xs" />
              {{ 'sis.search.link' | translate }}
            </a>
          </div>
        </div>
        <div class="c__actions">
          <button sd-button (click)="onSubmit()" (keydown.enter)="onSubmit()" [disabled]="disableSubmit">
            <span> {{ 'sis.search.button' | translate }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>

  @if (linkCards.length > 0) {
    <ul sd-list-inline [alignement]="positionEnum.top" class="is-m">
      @for (card of linkCards; track card) {
        <li class="col-24 col-m-12 col-l-8">
          <sd-link-card [linkCard]="card" [titleLevel]="2" />
        </li>
      }
    </ul>
  }

  @if (productInfos.length > 0) {
    <div id="product-customer-list" class="c__product-customer-list">
      <ul class="c__items">
        @for (item of currentProductInfos; track item) {
          <li>
            <div class="c__item">
              <sd-product-customer
                [indexFollow]="item?.indexFollow"
                [productInfo]="item"
                [isReadOnly]="true"
                [hasNoActions]="false"
                [canAddToCart]="false"
                [isMinified]="true"
                [customLinks]="true"
                [isRegistered]="false"
                [isWishList]="true"
                [showAllRef]="showAllRef"
                (click)="selectProduct(item)"
              />
            </div>
          </li>
        }
      </ul>
      @if (paginationTotalPages > 1) {
        <div class="c__actions">
          <sd-pagination
            [linkUrl]="linkUrl"
            [activePage]="(currentPage + 1)"
            [pages]="paginationTotalPages"
            (clickedPage)="onClickedPage($event)"
          />
        </div>
      }
    </div>
  }

  @if (isRegister && productInfos.length === 0 && linkCards.length === 0) {
    <p>
      {{ 'account.registerProduct.noResult' | translate }}
    </p>
  }

  @if (previousCategoryButton) {
    <a
      sd-button
      class="c__back-button"
      [isSmall]="true"
      icon="icon-arrow-left"
      [routerLink]="[urlParentCategoryCode]"
    >
      <span>{{ 'sis.actions.prev' | translate }}</span>
    </a>
  }
</sd-border-wrapper>

@if (isLoading) {
  <div sd-loader></div>
}

@defer (when isRefModalOpened) {
  <sd-modal-default
    [(isOpened)]="isRefModalOpened"
    [noPadding]="true"
    [modalTitle]="'accessory.search.modal.title' | translate"
  >
    <div sd-modal-body>
      <div>{{ 'accessory.search.modal.text' | translate }}</div>
      <br />
      <div>{{ 'accessory.search.modal.example' | translate }}</div>
      <sd-banner [media]="{ url: urlImage }" style="max-width: 42.6rem; margin: 2rem auto 0" />
    </div>
  </sd-modal-default>
}